import React from 'react';
import FASTLinkIcon from '../../FASTLogineApp/FASTLinkIcon';
import { Typography } from '@mui/material';
import './product-toolkit-card.scss';

export default function ProductToolkitsCard(data) {
  const { ProductName, ProductToolkitLink, FormsLink, AppPackageLink, TrainingLink, eAppLink } =
    data.data;

  return (
    <div className="ProductToolkitsCardContainer">
      <a className="ProductToolkitsCardHeader" href={ProductToolkitLink}>
        {ProductName}
      </a>
      <div className="ProductToolkitsCardImageContainer">
        <div className="ProductToolkitsCardImageGrid">
          <div></div>
          <div></div>
          {FormsLink && FormsLink !== '' && (
            <a href={FormsLink}>
              <img src="/images/forms.png" title="Forms" alt="Form Icon" />
            </a>
          )}
          {AppPackageLink && AppPackageLink !== '' && (
            <a href={AppPackageLink}>
              <img src="/images/package.png" title="App Package" alt="App Package Icon" />
            </a>
          )}
          {TrainingLink && TrainingLink !== '' && (
            <a href={TrainingLink}>
              <img src="/images/training.png" title="Training" alt="Training Icon" />
            </a>
          )}
          {eAppLink && eAppLink !== '' && (
            <>
              {eAppLink === 'FASTComponent' ? (
                <FASTLinkIcon id={Math.floor(Math.random() * 10)} />
              ) : (
                <a href={eAppLink} target="_blank" rel="noreferrer">
                  <img src="/images/eApp.png" title="eApp" alt="eApp Icon" />
                </a>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
